<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ title }}
                        <div class="clear"></div>
                    </div>
                        <shipping-component v-if="showComponent" :orderKey="orderKey"></shipping-component>

                </div>
                <page-footer></page-footer>
            </div>
        </div>
        <order-information-cart-list-modal></order-information-cart-list-modal>
    </div>
</template>

<script>
import ShippingComponent from "@/components/order/ShippingComponent.vue";
import OrderInformationCartListModal from "@/components/modal/OrderInformationCartListModal.vue";
import EventBus from "../../mixins/event-bus";

export default {
    name: "shippingDetail",
    mixins: [],
    components: {
        ShippingComponent,
        OrderInformationCartListModal,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            title: this.$route.meta.title,
            orderKey : this.$route.params.idx,
            showComponent: true,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        cancelOrder(){
            this.createConfirm({
                content: '주문을 취소하시겠습니까?',
                confirm: () => {
                    EventBus.$emit('updateStatus',105)
                }
            })
        },
        update(){
            this.createConfirm({
                content: '배송 준비중으로 변경하시겠습니까?',
                confirm: () => {
                    EventBus.$emit('updateStatus',30)
                }
            })
        },
    },
    watch: {
        '$route.path': {
            deep: true,
            handler: function (val, oldVal) {
                if(this.orderKey != this.$route.params.idx) {
                    this.orderKey = this.$route.params.idx;
                    this.showComponent = false;
                    this.$nextTick(() => {
                        this.showComponent = true;
                    })
                }
            }
        },
    },
}
</script>

<style scoped>

</style>
